import Swiper, { Navigation } from 'swiper';
import debounce from 'Utils/Debounce';
Swiper.use([Navigation]);

class ReferenceSlider {
	static MULTI_BREAKPOINT = 768;

	static MODE_SINGLE = 'single';
	static MODE_MULTI = 'multi';

	static SIZE_SMALL = 'small';
	static SIZE_BIG = 'big';

	constructor(el) {
		this.root = el;

		this.swiperContainer = this.root.querySelector('.js-referenceSliderContainer');
		this.cards = Array.from(this.root.querySelectorAll('.js-refCard'));
		this.rebuildDOM();
		this.initSlider();
		window.addEventListener('resize', debounce(::this.rebuildDOM, 250));
	}

	rebuildDOM() {
		const targetMode =
			window.innerWidth < ReferenceSlider.MULTI_BREAKPOINT
				? ReferenceSlider.MODE_SINGLE
				: ReferenceSlider.MODE_MULTI;
		if (this.currentMode === targetMode) return;
		this.currentMode = targetMode;

		const tempContainer = document.createElement('div');
		this.cards.forEach(card => {
			tempContainer.appendChild(card);
		});

		const refSlides = Array.from(this.root.querySelectorAll('.js-refSlide'));

		var refSlideTemplate = refSlides[0].cloneNode();

		refSlides.forEach(refSlide => {
			refSlide.parentNode.removeChild(refSlide);
		});

		let currentSize;
		let currentSlide;

		this.cards.forEach(card => {
			const cardSize = card.dataset.size;
			if (
				currentSize == null ||
				currentSize === ReferenceSlider.SIZE_BIG ||
				this.currentMode === ReferenceSlider.MODE_SINGLE
			) {
				currentSlide = refSlideTemplate.cloneNode();
				currentSlide.appendChild(card);
				this.swiperContainer.firstChild.appendChild(currentSlide);
				currentSize = cardSize;
			} else if (currentSize === ReferenceSlider.SIZE_SMALL) {
				currentSlide.appendChild(card);
				currentSize = null;
			}
		});

		if (this.swiper) {
			this.swiper.update();
			this.swiper.slideTo(0, 1, false);
		}
	}

	initSlider() {
		this.swiper = new Swiper(this.swiperContainer, {
			spaceBetween: 10,
			slidesPerView: 1,
			grabCursor: true,
			resistanceRatio: 0,
			slideActiveClass: 'is-active',

			navigation: {
				nextEl: this.root.querySelector('.js-referenceSliderArrowNext'),
				prevEl: this.root.querySelector('.js-referenceSliderArrowPrev'),
				disabledClass: 'is-disabled',
			},

			breakpoints: {
				768: {
					slidesPerView: 'auto',
					spaceBetween: 20,
				},
				1240: {
					spaceBetween: 20,
					slidesPerView: 'auto',
				},
			},
		});
	}
}

Array.from(document.querySelectorAll('.js-referenceSlider')).forEach(el => new ReferenceSlider(el));
